
//import errorHandler from './errorHandler'
 import api from '../../../api'
 import publicApi from '../../../api/public'
 import _ from 'lodash'

export default {
    create : (payload, next) => {
        api.post('/api/v1/users', payload, (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    createWith : (payload, next) => {
        api.post('/api/v1/users?with=' + payload.with, payload, (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    getUserByEmail : (payload, next) => {
        api.get('/api/v1/users/'+ payload.query.email +'.email', (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    getUserById : (payload, next) => {
        api.get('/api/v1/users/'+ payload.query.userId, (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    changePasswordByUserId : (payload, next) => {
        api.put('/api/v1/users/' + payload.query.userId + '/password', payload.body,(err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    ChangeNameByUserId : (payload, next) => {
        api.put('/api/v1/users/' + payload.query.userId, payload.body,(err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    ChangeCreatedAtByUserId : (payload, next) => {
        api.put('/api/v1/users/' + payload.query.userId, payload.body,(err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    ChangeEmailByUserId : (payload, next) => {
        api.put('/api/v1/users/' + payload.query.userId + '/email', payload.body,(err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    whiteLabelAvatarUpdate : (payload, next) => {
        api.put('/api/v1/users/' + payload.query.userId + '/brand/avatar', payload.formData,(err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    subdomainCreate : (payload, next) => {
        api.post('/api/v1/users/' + payload.query.userId + '/brand/domains/juphy.com/records', payload.body,(err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    deleteSubdomain : (payload, next) => {
        api.delete('/api/v1/users/' + payload.query.userId + '/brand/domains/juphy.com/records/'+ payload.query.name ,(err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    cnameCreate : (payload, next) => {
        api.post('/api/v1/users/' + payload.query.userId + '/brand/domains', payload.body,(err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    forgotPassword : (payload, next) => {
        publicApi.put('/api/v1/users/' + payload.query.email + '.email/password.reset', {},(err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    deleteCname : (payload, next) => {
        api.delete('/api/v1/users/' + payload.query.userId + '/brand/domains/'+payload.query.name, (err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    resendInvitation : (payload, next) => {
        api.post('/segment/users/'+ payload.query.userId +'.track', payload.body,(err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    addPhone : (payload, next) => {
        api.post('/api/v1/users/' +  payload.query.userId + '/phones', payload.body,(err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    updatePreferencesForWorkspace : (payload, next) => {
        api.put('/api/v1/users/' + payload.query.userId + '/preferences/workspace', payload.body,(err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    },
    updateUserProperties : (payload, next) => {
        api.put('/api/v1/users/' + payload.query.userId, payload.body,(err, data) => {
            if(err) return next(err, null);

            //Trick for workspaces "lodash get"
            next(null, data);
        })   
    }
} 





// WEBPACK FOOTER //
// ./src/libs/system/services/user.js